export default {
  data () {
    return {}
  },
  methods: {
    triggerInputEvent (id) {
      const ele = document.getElementById(id)
      if (!ele) return
      ele.dispatchEvent(new Event('input'))
      ele.dispatchEvent(new Event('blur'))
    },
    triggerSelect (id) {
      document.getElementById(id).parentElement.dispatchEvent(new Event('MDCSelect:change', { bubbel: true }))
    }
  }
}
